export const TYPE_OPTIONS = [
  { label: "ฉ.", value: 1 },
  { label: "นส3ก.", value: 2 },
  { label: "ห้องชุด", value: 3 },
  { label: "อาคารชุด", value: 4 },
  { label: "นภ.1", value: 5 },
  { label: "อื่น ๆ", value: 6 },
];
